/**
 * Caropaera War Hero (145): pending redeem ghost overlays for viewer.
 */

const CAROPAERA_REDEEM_GHOST_SOURCE = 'caropaera_war_hero_145';

function consumePendingCaropaeraRedeemGhostAnimations(gameStateFragment, viewerUserId) {
  if (!gameStateFragment?.pendingCaropaeraRedeemGhostAnimations?.length) {
    return [];
  }
  if (viewerUserId == null) {
    throw new Error('consumePendingCaropaeraRedeemGhostAnimations: viewerUserId is required');
  }

  const pending = [...gameStateFragment.pendingCaropaeraRedeemGhostAnimations];
  delete gameStateFragment.pendingCaropaeraRedeemGhostAnimations;

  return pending.map((anim) => {
    if (!anim.animationKey) {
      throw new Error('consumePendingCaropaeraRedeemGhostAnimations: animationKey is required');
    }
    if (!anim.unitInstanceId) {
      throw new Error(`consumePendingCaropaeraRedeemGhostAnimations: unitInstanceId required for ${anim.animationKey}`);
    }
    if (anim.targetZone == null || anim.targetSlotIndex == null || anim.targetPlayerId == null) {
      throw new Error(`consumePendingCaropaeraRedeemGhostAnimations: slot required for ${anim.animationKey}`);
    }
    const prefix = String(anim.targetPlayerId) === String(viewerUserId) ? 'your' : 'opponent';
    return {
      key: anim.animationKey,
      source: anim.source || CAROPAERA_REDEEM_GHOST_SOURCE,
      unitInstanceId: anim.unitInstanceId,
      durationMs: anim.durationMs,
      viewerZone: `${prefix}_${anim.targetZone}`,
      viewerIndex: anim.targetSlotIndex,
    };
  });
}

module.exports = {
  consumePendingCaropaeraRedeemGhostAnimations,
};
